import axios from "axios";
import { getTokenData } from "./Auth__Service";
import { getConfigHeader, refrech, URL_NOTIFICATION } from "./config";

const findAllByReceiverLogin = async (login) => {
  return refrech()
    .then(() =>
      axios.get(
        URL_NOTIFICATION +
          "?receiver_login=" +
          login +
          "&receiver_type=" +
          getTokenData().profil,
        getConfigHeader()
      )
    )
    .catch((error) => Promise.reject(error));
};

const setRead = async (id) => {
  const formData = new FormData();

  formData.append("id", id);

  return refrech()
    .then(() => axios.post(URL_NOTIFICATION, formData, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

export { findAllByReceiverLogin, setRead };
